import { buyProductShopOrdersPost } from '@/shared/api/intranet'

import type { CartItem, CreateOrderParams, OrderIn } from '../model'

export const buyProducts = async (cartItems: CartItem[], params: CreateOrderParams) => {
  const body: OrderIn = {
    order_products: cartItems.map(({ product_id, product_sku_id, quantity }) => ({
      product_id,
      quantity,
      product_sku_id,
    })),
    ...params,
  }
  return buyProductShopOrdersPost({ body })
}
